import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: string;
    cancel: string;
    confirm: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title warning that the folder being shared has active upload links */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmUploadLinkShareDialog.title?c=ofeo6pjq2pmi", defaultMessage: "This folder has active Upload Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog description explaining that share viewers can see uploaded assets */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmUploadLinkShareDialog.description?c=1lwors64ds8jf", defaultMessage: "If you create a Share Link, recipients will be able to view any uploaded assets." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to cancel the Share creation */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmUploadLinkShareDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to confirm and continue sharing */
            confirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmUploadLinkShareDialog.confirm?c=30mq6qmtw3sxr", defaultMessage: "Share Anyway" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
